function AdsForm() {
  return (
    <div className="border rounded p-4">
      <h5 className="fw-semibold mb-3">Create Ad</h5>

      <div className="row g-3">
        {/* Ad Name */}
        <div className="col-md-6">
          <label className="form-label">Ad Name</label>
          <input
            className="form-control"
            placeholder="Homepage Banner Campaign"
          />
        </div>

        {/* Ad Placement */}
        <div className="col-md-6">
          <label className="form-label">Ad Placement</label>
          <select className="form-select">
            <option>Homepage Ad</option>
            <option>Category Level</option>
          </select>
        </div>

        {/* Duration */}
        <div className="col-md-3">
          <label className="form-label">Start Date</label>
          <input type="date" className="form-control" />
        </div>

        <div className="col-md-3">
          <label className="form-label">End Date</label>
          <input type="date" className="form-control" />
        </div>

        {/* Apply To */}
        <div className="col-md-6">
          <label className="form-label">Apply To</label>
          <select className="form-select">
            <option>Selected Items</option>
          </select>
        </div>

        {/* Actions */}
        <div className="col-12 mt-3">
          <button className="btn btn-primary">Apply</button>
        </div>
      </div>
    </div>
  );
}
export default AdsForm;
